export enum UnitTypesEnum {
  'g'= 'g',
  'ml' = 'ml',
  'Stuck' = 'Stück',
  'manually' = 'manually'
}
